module.exports = __webpack_public_path__ + "img/0.e03e1eb9.jpg";